export const materialSymbolUnicode = {
    account_balance: 59471,
    account_circle: 61963,
    add: 57669,
    add_card: 60294,
    add_circle: 59792,
    alternate_email: 57574,
    apps: 58819,
    archive: 57673,
    arrow_back: 58820,
    arrow_downward: 58843,
    arrow_drop_down: 58821,
    arrow_drop_up: 58823,
    arrow_forward: 58824,
    arrow_upward: 58840,
    article: 61319,
    attach_file: 57894,
    backspace: 57674,
    bar_chart: 57963,
    block: 61580,
    bolt: 59915,
    cake: 59369,
    calendar_clock: 62784,
    calendar_month: 60364,
    calendar_today: 59701,
    calendar_view_month: 61415,
    card_membership: 59639,
    check: 58984,
    check_box_outline_blank: 59445,
    check_circle: 61630,
    chevron_left: 58827,
    chevron_right: 58828,
    circle: 61258,
    close: 58829,
    content_copy: 57677,
    dashboard: 59505,
    date_range: 59670,
    delete: 59694,
    description: 59507,
    devices: 58150,
    distance: 63210,
    do_not_disturb_on: 61583,
    done_all: 59511,
    download: 61584,
    drafts: 57681,
    drag_indicator: 59717,
    edit: 61591,
    error: 63670,
    event_available: 58900,
    event_busy: 58901,
    event_repeat: 60283,
    exercise: 63206,
    expand: 59727,
    favorite: 59518,
    female: 58768,
    filter_list: 57682,
    folder_open: 58056,
    format_align_center: 57908,
    format_align_justify: 57909,
    format_align_left: 57910,
    format_align_right: 57911,
    format_bold: 57912,
    format_clear: 57913,
    format_color_fill: 57914,
    format_color_text: 57916,
    format_indent_decrease: 57917,
    format_indent_increase: 57918,
    format_italic: 57919,
    format_list_bulleted: 57921,
    format_list_numbered: 57922,
    format_underlined: 57929,
    forum: 59567,
    grid_on: 58348,
    group: 59937,
    group_add: 59376,
    help: 59645,
    home: 59826,
    how_to_reg: 57716,
    image: 58356,
    info: 59534,
    insert_chart: 61644,
    keyboard_arrow_down: 58131,
    keyboard_arrow_right: 58133,
    keyboard_arrow_up: 58134,
    language: 59911,
    left_panel_close: 63255,
    link: 57936,
    link_off: 57711,
    lock: 59545,
    logout: 59834,
    mail: 57689,
    male: 58766,
    mark_email_read: 61836,
    menu: 58834,
    mobile: 59322,
    more_horiz: 58835,
    more_vert: 58836,
    notifications: 59381,
    open_in_new: 59550,
    paid: 61505,
    person_add: 59981,
    photo_camera: 58386,
    picture_as_pdf: 58389,
    place: 61915,
    play_arrow: 57399,
    redeem: 59638,
    redo: 57690,
    remove: 57691,
    save: 57697,
    schedule: 61398,
    science: 59979,
    search: 61306,
    sell: 61531,
    send: 57699,
    settings: 59576,
    shopping_cart: 59596,
    skip_next: 57412,
    smart_toy: 61548,
    sms: 58917,
    stars_2: 62236,
    stop: 57415,
    storefront: 59922,
    support_agent: 61666,
    swap_horiz: 59604,
    swap_vert: 59605,
    switch_account: 59885,
    sync: 58919,
    table_chart: 57957,
    table_rows: 61697,
    task: 61557,
    task_alt: 58086,
    text_fields: 57954,
    text_snippet: 61894,
    thumb_down: 62840,
    thumb_up: 62839,
    timer: 58405,
    today: 59615,
    topic: 61896,
    transgender: 58765,
    tune: 58409,
    undo: 57702,
    upload_file: 59900,
    vertical_align_bottom: 57944,
    vertical_align_center: 57945,
    vertical_align_top: 57946,
    videocam_off: 57420,
    view_column: 59628,
    visibility: 59636,
    visibility_off: 59637,
    wand_stars: 62238,
    warning: 61571,
    widgets: 57789,
    window: 61576,
    wrap_text: 57947,
    zoom_out_map: 58731
} as const;
